export default __webpack_public_path__ + "static/media/flow-meter.8d87acd7.jpg";